import { useTranslation } from 'react-i18next';
import { Card } from '@sib/ui';
import WorkInProgress from '../../../public/images/workInprgress.webp';

export const EmptyPagePlaceholder = () => {
  const { t } = useTranslation();

  return (
    <div className="relative flex size-full flex-row items-center justify-center bg-[url('placeholder-bg.png')] bg-[length:100%_100%] bg-center">
      <div className="absolute inset-0 z-10 bg-slate-200/75" />
      <Card className="animate-dissolve z-20 m-2 mx-4 flex w-full max-w-[550px] flex-col items-center justify-center gap-4 rounded-2xl p-8 shadow-none">
        <p className="text-xl font-semibold">
          {t('emptyPagePlaceholder.title')}
        </p>
        <div className="bg-primary/5 flex flex-col items-center justify-center rounded-full">
          <img
            src={WorkInProgress}
            width={530}
            height={488}
            alt="Work in progress"
          />
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          <p className="text-muted-foreground text-xs">
            {t('emptyPagePlaceholder.description')}
          </p>
        </div>
      </Card>
    </div>
  );
};
